import { ACTIONS } from "../../../Models/ENUM";
import CONQUER from "../../CONQUER";
import PostInstance from "../POST_INSTANCE/PostInstance";
import Followers from "./FOLLOWERS/Followers";

class FeedInstance
{
    private conquer     : CONQUER;

    public feedID           : any;
    public type             : string;
    public memberIDs        : any = [];
    public tags             : any = [];
    public searchParams     : any = false;
    public posts            : any = [];
    public followers        : number = 0;
    public Followers        : Followers;
 
    constructor( conquer:CONQUER, data:any )
    {
        this.conquer        = conquer;
        this.type           = data.type || "posts";
        this.memberIDs      = data.memberIDs || [];
        this.tags           = data.tags || [];
        this.searchParams   = data.searchParams || false;
        this.posts          = data.posts || [];
        this.followers      = data.followers || 0;

        this.Followers      = new Followers( this.conquer, this );
    }

    public async get() : Promise<any> // pagination
    {
        let search : any = 
        {
            type            : this.type,
            memberIDs       : this.memberIDs,
            searchParams    : this.searchParams,
            tags            : this.tags
        };

        let data : any = await this.conquer.do( ACTIONS.POST_GET, { search:search });

        for( let n in data ) {
            this.posts.push( new PostInstance( this.conquer, data[n] ));
        }

        return Promise.resolve( this.posts );
    }

 
};

export default FeedInstance;